﻿import { readString } from 'react-papaparse';

export function getMessageFromPromiseReject(reason: any): string {

    switch (true) {

        case reason instanceof Error:
            return reason.message;
        case typeof reason === 'string':
            return reason;
        default:
            return 'An unknown error occurred.';

    }

}

export function getIdFromURL(urlParam: string) {

    const stringId = new URL(location.href.toLowerCase()).searchParams.get(urlParam.toLowerCase());
    if (stringId !== null) {

        const idList = stringId.split(',');
        const nums = idList.map(function (str) {

            return parseInt(str);

        });
        return nums;

    }

}

export function getStringFromURL(urlParam: string) {

    const stringId = new URL(location.href.toLowerCase()).searchParams.get(urlParam.toLowerCase());
    if (stringId !== null) {

        return stringId;

    }

}

// The current pathname + query string. Passed as location state (`from`) when opening a
// detail page so breadcrumbs and back-navigation can restore the lookup's filtered URL.
export const currentLookupUrl = () => window.location.pathname + window.location.search;

// Reads the report id from the `/reports/:reportId` path segment, if present.
export function getReportIdFromPath(): string | null {

    const match = location.pathname.match(/\/reports\/(\d+)/i);
    return match ? match[1] : null;

}

// True when the app is running inside an iframe (e.g. a report opened in a modal).
// Used to hide the app nav and lock report filters for embedded views.
export function isEmbedded(): boolean {

    try {

        return window.self !== window.top;

    } catch {

        // Cross-origin parent access throws, which only happens when framed.
        return true;

    }

}

interface NewStudentTabRequest {
    from: 'Groups/Default.aspx';
    studentId: number;
}

interface NewTransactionTabRequest {
    from: 'Groups/Default.aspx' | 'Students/Default.aspx';
    transactionId: number;
}

interface NewGroupTabRequest {
    from: 'Students/Default.aspx';
    groupId: number;
}

export interface CustomEvents {
    NewGroupTabRequest: NewGroupTabRequest;
    NewStudentTabRequest: NewStudentTabRequest;
    NewTransactionTabRequest: NewTransactionTabRequest;
}

export function addCustomEventListener<T extends keyof CustomEvents>(
    eventName: T,
    listener: (detail: CustomEvents[T]) => void
) {

    const action = (event: Event) => {

        (event as CustomEvent).detail && listener((event as CustomEvent).detail);

    };
    window.addEventListener(eventName, action);
    return () => window.removeEventListener(eventName, action);

}

export function dispatchCustomEvent<T extends keyof CustomEvents>(
    window: Window,
    eventName: T,
    detail: CustomEvents[T]
) {

    const event = new CustomEvent(eventName, { detail });
    window.dispatchEvent(event);

}

export const validTestAttemptsAmount = (value: string, maxAmountAllowed = 999): number => {

    let validateValidNumOfTestAttempts = parseInt(value);
    if (validateValidNumOfTestAttempts > (maxAmountAllowed === -1 ? 999 : maxAmountAllowed)) {

        validateValidNumOfTestAttempts = maxAmountAllowed === -1 ? 999 : maxAmountAllowed;

    }
    if (validateValidNumOfTestAttempts < 1) {

        validateValidNumOfTestAttempts = 1;

    }
    return validateValidNumOfTestAttempts;

};

export const convertFileTo = (file: any, setData: React.Dispatch<React.SetStateAction<any>>) => {

    readString(file, {
        complete: results => {

            setData(results);

        },
        worker: false
    });

};

export const handlePersistantUrl = (paramProp: string, value: number) => {

    const url = new URL(window.location.href);
    const search_params = url.searchParams;
    const urlIdListString = search_params.get(paramProp);
    if (urlIdListString === null) {

        search_params.set(paramProp, value.toString());

    } else {

        let numberInArray = false;
        urlIdListString.split(',').map(number => {

            if (parseInt(number) === value) {

                numberInArray = true;

            }

        });
        if (!numberInArray) {

            search_params.set(paramProp, urlIdListString + ',' + value.toString());

        }

    }
    url.search = search_params.toString();
    window.history.pushState(null, '', url);

};

export const setStringParamInUrl = (paramProp: string, value: string) => {

    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const trimmedValue = value.trim();
    const currentValue = searchParams.get(paramProp);

    if (trimmedValue.length === 0) {

        if (currentValue === null) return;
        searchParams.delete(paramProp);

    } else {

        if (currentValue === trimmedValue) return;
        searchParams.set(paramProp, trimmedValue);

    }

    url.search = searchParams.toString();
    window.history.replaceState(null, '', url);

};

export const removeParamFromUrl = (url: string, param: string) => {

    const urlParts = url.split('?');
    const baseUrl = urlParts[0];
    const queryString = urlParts[1];
    if (urlParts && urlParts[1]) {

        const params = queryString.split('&');
        const updatedParams = params.filter(paramValuePair => {

            const [key] = paramValuePair.split('=');
            return key !== param;

        });
        const updatedQueryString = updatedParams.join('&');
        return updatedQueryString ? `${baseUrl}?${updatedQueryString}` : baseUrl;

    } else {

        return baseUrl;

    }

};
